// removed by extract-text-webpack-plugin
module.exports = {"tip-wrapper":"tip-wrapper","ant-tooltip":"ant-tooltip","ant-tooltip-inner":"ant-tooltip-inner","ant-tooltip-content":"ant-tooltip-content","ant-tooltip-arrow":"ant-tooltip-arrow","ant-tooltip-placement-bottom":"ant-tooltip-placement-bottom","ant-tooltip-placement-bottomLeft":"ant-tooltip-placement-bottomLeft","ant-tooltip-placement-bottomRight":"ant-tooltip-placement-bottomRight"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/MaterialTip/materialTip.scss
// module id = 920
// module chunks = 0